import React from 'react';
import withLabelAndMeta from './withLabelandMeta';

const Input = ({
  field, // { name, value, onChange, onBlur }
  fieldDefinition,
}) => (
  <input id={fieldDefinition.key} {...field} />
);

export default withLabelAndMeta(Input);
